import { useMutation } from '@tanstack/react-query';
import { askQuestionService } from './ChatAssist.services';

export const useAskQuestionMutation = () => useMutation(askQuestionService);
